import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { trackJobmailActivation } from '../../tracking'
import {
  GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_POPUP_ACTIVATION_RESEND,
  GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_SLIDE_ACTIVATION_RESEND
} from '../../tracking/constants'
import { resendActivation } from '../store/actions'
import { getOpenSearchJobmailDueToScroll } from '../store/selectors'

const SuccessNotificationMessage = ({ email, showResendLink }) => {
  const dispatch = useDispatch()
  const openDueToScroll = useSelector(getOpenSearchJobmailDueToScroll)
  const onResendActivation = useCallback((event) => {
    event.preventDefault()
    dispatch(resendActivation(email))

    if (openDueToScroll) {
      trackJobmailActivation(GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_SLIDE_ACTIVATION_RESEND)
    } else {
      trackJobmailActivation(GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_POPUP_ACTIVATION_RESEND)
    }
  }, [dispatch, email, openDueToScroll])

  return (
    <div>
      <h2 className='title'>Fast geschafft</h2>
      <p>
        Nur noch ein Schritt. Wir haben Ihnen eine E-mail an {email} gesendet.
        Bitte bestätigen Sie Ihre E-Mail-Adresse durch Anklicken des
        Links in der E-Mail
      </p>
      {showResendLink &&
        <p>
          Keine Mail erhalten?
          <a href='#' className='d-block qa-jm-re-act' onClick={onResendActivation}>
            Klicken Sie hier, um den Mailversand erneut zu starten.
          </a>
        </p>}
    </div>
  )
}

SuccessNotificationMessage.propTypes = {
  email: PropTypes.string.isRequired,
  showResendLink: PropTypes.bool
}

export default SuccessNotificationMessage
